import React from "react";
import CelebrantsGrid from "../../components/celebrant/celebrantgrid";
import celebrant from "../../assets/celebrant.png";

const Workcelebrant = () => {
  const celebrants = [
    {
      id: 1,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      image: celebrant, // replace with actual image
      isToday: false,
    },
    {
      id: 2,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      image: celebrant,
      isToday: false,
    },
    {
      id: 3,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      image: celebrant,
      isToday: true, // highlight today's celebrant
    },
    {
      id: 4,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      image: celebrant,
      isToday: false,
    },
    {
      id: 5,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      image: celebrant,
      isToday: false,
    },
    {
      id: 6,
      name: "Adebimpe Peters",
      role: "HR Personnel",
      date: "31st March",
      image: celebrant,
      isToday: false,
    },
  ];
  return (
    <div>
      <CelebrantsGrid
        title="Birthday Celebrants - September"
        celebrants={celebrants}
      />
    </div>
  );
};

export default Workcelebrant;
